'use strict'

module.exports = wbr

function wbr(h, node) {
  return h(node, 'text', '\u200b')
}
